import { assertSpaceItemPersistable } from '@sb/remote-control/util/assertSpaceItemPersistable';
import { convertGlobalSpaceResponse } from '@sb/remote-control/util/convertGlobalSpaceResponse';
import type { Space } from '@sb/routine-runner';

import { getGlobalSpaceService } from './utils/getGlobalSpaceService';

/**
 * Create a global space item. Returns the stored row: its id, and the item
 * carrying the version the server assigned, so a write that follows before
 * the subscription echoes the row back can still be guarded.
 */
export async function createGlobalSpace(
  globalSpace: Space.Item,
): Promise<{ globalSpaceID: string; spaceItem: Space.Item }> {
  assertSpaceItemPersistable(globalSpace);

  const response = await getGlobalSpaceService().create({
    spaceItem: globalSpace,
  });

  const converted = convertGlobalSpaceResponse(response);

  if (!converted) {
    throw new Error('Created global space could not be read.');
  }

  return converted;
}
